import type { StyleRule } from '@archipro-design/aria';
import { HeaderClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem, labelClassName, boxClassName } from '@archipro-design/aria';

import { ABOUT_BANNER_SIZE } from '@modules/professional/config/constants';

export const InfoContainer: StyleRule = ({ theme }) => ({
    display: 'block',
    justifyContent: 'normal',

    [theme.screen.laptop]: {
        gridTemplateColumns: `${pxToRem(ABOUT_BANNER_SIZE)} 1fr`,
        gridGap: pxToRem(43),

        display: 'inherit',
        justifyContent: 'inherit',
        marginBottom: 'inherit',
    },
});

export const InfoWrap: StyleRule = ({
    theme,
    hasBannerImage,
    hasCustomTabs,
}) => ({
    margin: pxArrayToRem([0, 18]),
    '& > div:not(:last-child)': {
        marginBottom: pxToRem(35),
    },

    [theme.screen.laptop]: {
        '& > div:not(:last-child)': {
            marginBottom: pxToRem(18),
        },
        [`& .${boxClassName} > *`]: {
            paddingBottom: 0,
        },

        margin: 'unset',
        borderTop: `1px solid ${theme.siteVariables.colors.primitive.black}`,

        borderBottom:
            hasBannerImage || hasCustomTabs
                ? 0
                : `1px solid ${theme.siteVariables.colors.primitive.black}`,
        minHeight: hasBannerImage ? 'unset' : pxToRem(346),
    },
});

export const AboutHeader: StyleRule = ({ theme }) => ({
    [`&.${HeaderClassName}`]: {
        letterSpacing: pxToRem(0.4),
        lineHeight: 1.75,
        fontSize: pxToRem(20),
        margin: pxArrayToRem([96, 0, 18]),
        ...theme.siteVariables.textStyles.Text.Medium65,
    },
});

export const ButtonStyle: StyleRule = ({ theme }) => ({
    [`& > button`]: {
        fontSize: theme.siteVariables.fontSizes.caption03,
        ':hover': {
            background: 'none',
        },
    },

    [`& > button .${labelClassName}`]: {
        fontSize: theme.siteVariables.fontSizes.caption03,
        lineHeight: 1,
        textUnderlineOffset: pxToRem(3),
    },

    [theme.screen.laptop]: {
        [`& > button .${labelClassName}`]: {
            fontSize: theme.siteVariables.fontSizes['label03-alt'],
            fontWeight: theme.siteVariables.fontWeightLight,
            letterSpacing: theme.siteVariables.letterSpacingSmall,
            lineHeight: theme.siteVariables.lineHeightSmall,
            marginTop: pxToRem(3),
        },
    },
});

export const ReadMoreText: StyleRule = ({ theme }) => {
    return {
        marginRight: 0,
        marginLeft: 0,

        '& > button': {
            padding: 0,
            marginTop: pxToRem(20),
            justifyContent: 'flex-start',
            display: 'flex',
            '& > div': {
                letterSpacing: theme.siteVariables.letterSpacingSmall,
                lineHeight: 1,
                textUnderlineOffset: pxToRem(3),
            },
        },
        [`> .${boxClassName} > *`]: {
            margin: 'unset',
        },

        [`& > .${boxClassName} p`]: {
            '& a': {
                color: 'inherit',
                textDecoration: `underline`,
                textDecorationThickness: pxToRem(1.5),

                '&:hover': {
                    color: `${theme.siteVariables.colors.charcoal['000']}`,
                },
            },
        },

        '& a': {
            color: 'inherit',
            textDecoration: `underline`,
            textDecorationThickness: pxToRem(1.5),

            '&:hover': {
                color: `${theme.siteVariables.colors.charcoal['000']}`,
            },
        },

        [`& > .${boxClassName} p:first-child`]: {
            marginTop: pxToRem(2),
        },

        [theme.screen.laptop]: {
            marginTop: 0,
            fontSize: theme.siteVariables.fontSizes['label03-alt'],
            fontWeight: theme.siteVariables.fontWeightLight,
            letterSpacing: theme.siteVariables.letterSpacingSmall,

            [`& > p:first-child`]: {
                marginTop: pxToRem(0),
            },
            [`& > p`]: {
                color: theme.siteVariables.colorScheme.default?.foreground,
                fontSize: theme.siteVariables.fontSizes['label03-alt'],
                fontWeight: theme.siteVariables.fontWeightLight,
                letterSpacing: theme.siteVariables.letterSpacingSmall,
            },
        },
    };
};
